import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Link from '@mui/material/Link';
import TableCell from 'components/TableCell';
import SortableEntityTableRow, {
  SortableEntityTableRowProps,
} from 'components/SortableEntityTableRow';

import { DepartureLocationListRow_departureLocation$key } from '__generated__/DepartureLocationListRow_departureLocation.graphql';

type Props = SortableEntityTableRowProps & {
  departureLocation: DepartureLocationListRow_departureLocation$key;
};

const DepartureLocationListRow: FC<Props> = props => {
  const { departureLocation, ...rest } = props;

  const departureLocationData = useFragment(
    graphql`
      fragment DepartureLocationListRow_departureLocation on DepartureLocation {
        id
        name

        ...SortableEntityTableRow_entity
      }
    `,
    departureLocation
  );

  const { id, name } = departureLocationData;

  return (
    <SortableEntityTableRow entity={departureLocationData} {...rest}>
      <TableCell>
        <Link href={id}>{name}</Link>
      </TableCell>
    </SortableEntityTableRow>
  );
};

export default DepartureLocationListRow;
